import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
    setLoading(false);
  };

  useEffect(() => { loadMe(); }, []);

  const setSession = (_token, u) => {
    setUser(u);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* session already gone */ }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setSession, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}
